import { InvoiceItemsTableBean } from './InvoiceItemsTable.types';

export const useUnitsPriceSum = (invoiceItems: InvoiceItemsTableBean[] | undefined): number | null => {
   if (!invoiceItems) {
      return null;
   }

   return invoiceItems.reduce((total: number | null, invoiceItem) => {
      if (total === null || invoiceItem.unitPrice === null || invoiceItem.quantity === null) {
         return null;
      }

      return total + invoiceItem.quantity * invoiceItem.unitPrice;
   }, 0);
};
